import React from 'react'
import PropTypes from 'prop-types'
import Icon from 'components/Icon'
import ChannelSelect from 'components/ChannelSelect'
import {Table, Column, Cell} from 'components/Table'
import URLPart from 'components/URLPart'
import {fetchUnmappedUtms, mapUtms} from 'redux/modules/settings/actions'
import {
  getUnmappedUtms,
  getMapUnmappedChannelSaving
} from 'redux/modules/settings/selectors'
import classnames from 'classnames'
import {connect} from 'react-redux'
import _ from 'lodash'
import ChannelGroupTitle from 'components/ChannelGroupTitle'
import ChannelTitle from 'components/ChannelTitle'

const checkMappingsOnChannel = (maps, chnls) => _.every(Object.keys(maps), p => maps[p] === chnls[p])

export class UmMappedView extends React.Component {
  static propTypes = {
    fetchUnmappedUtms: PropTypes.func,
    mapUtms: PropTypes.func,
    unmappedUtms: PropTypes.array,
    isUtmUnmappingsFetching: PropTypes.bool
  }

  static contextTypes = {
    permissions: PropTypes.object
  }

  constructor(props) {
    super(props)
    this.state = {
      selectedParameters: {},
      selectedChannel: null
    }
  }

  componentWillMount() {
    const {fetchUnmappedUtms} = this.props
    fetchUnmappedUtms()
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      selectedChannel: null,
      selectedParameters: {}
    })
  }

  render() {
    return (
      <div className='unmapped-view'>
        {this.renderUnmappedChannels()}
        {this.renderMappingForm()}
      </div>
    )
  }

  renderUnmappedChannels() {
    const {unmappedUtms, isUtmUnmappingsFetching} = this.props

    return (
      <div className='settings-unmapped-view_channels'>
        <div className='settings-unmapped-view_channels_intro'>
          Below are the UTM parameters not automatically recognized by us.
          Select the parameters you want to map and choose the correct Channel Group and Channel to the right.
        </div>
        <Table
          className='settings-unmapped-view_channels_table'
          data={unmappedUtms}
          loading={isUtmUnmappingsFetching}
          empty='There are no unmapped channels'
        >
          <Column
            header='UTM PARAMETERS'
            grow
            cell={data => (
              <Cell className='settings-unmapped-view_channels_table_url-cell'>
                {this.renderUnmappedChannel(data)}
              </Cell>
            )}
          />
          <Column
            header='Channel Group'
            grow
            width={140}
            cell={data => (
              <Cell>
                <ChannelGroupTitle id={data.channel.channelGroup} />
              </Cell>
            )}
          />
          <Column
            header='Channel'
            grow
            width={140}
            cell={data => (
              <Cell>
                <ChannelTitle id={data.channel.channel} iconSize='16px' />
              </Cell>
            )}
          />
          <Column
            header='Visits'
            width='100px'
            className='settings-unmapped-view_channels_table_visits'
            cell={data => <Cell className=''>{data.visits}</Cell>}
          />
        </Table>
      </div>
    )
  }

  renderUnmappedChannel(data) {
    const {channel: channels} = data
    const {selectedParameters} = this.state
    const matchedChannel = checkMappingsOnChannel(selectedParameters, channels)

    const classNames = classnames('settings-unmapped-view_url', {
      'is-matched': matchedChannel
    })

    return (
      <div className={classNames}>
        {Object.keys(channels).map((channel, index) => {
          const value = channels[channel]
          const active = selectedParameters[channel] && selectedParameters[channel] === value
          return (
            <URLPart
              key={index}
              index={index}
              type={channel}
              value={value}
              active={active}
              onClick={this.handleMappingClick}
            />
          )
        })}
      </div>
    )
  }

  renderMappingForm() {
    return (
      <div className='settings-unmapped-view_form'>
        <div className='settings-unmapped-view_form_title'>
          Create a new mapping
        </div>
        {this.renderMappings()}
        {this.renderChannelSelect()}
      </div>
    )
  }

  renderMappings() {
    const {selectedParameters} = this.state
    return (
      <div className='settings-unmapped-view_form_mappings'>
        From now on, whenever we encounter the selected parameters we will map to this channel:
        {Object.keys(selectedParameters).map((param, index) => {
          const value = selectedParameters[param]
          if (!value) return null

          const paramValue = `${param}=${value}`
          return (
            <div key={index} className='settings-unmapped-view_form_mapping'>
              <Icon className='settings-unmapped-view_form_mapping_icon' name='chevron' size='10px' />
              {paramValue}
            </div>
          )
        })}
      </div>
    )
  }

  renderChannelSelect() {
    const {selectedChannel} = this.state
    const disabled = !(this.hasActiveParameter() && selectedChannel)

    return (
      <div className='settings-unmapped-view_form_channel'>
        <ChannelSelect
          className='settings-unmapped-view_form_select'
          value={selectedChannel}
          onChannelSelect={this.selectChannel}
        />

        <button
          type='submit'
          className='settings-unmapped-view_form_submit'
          onClick={this.saveUnmappedChannel}
          disabled={disabled}>
          Save
        </button>
      </div>
    )
  }

  handleMappingClick = (type, value, active) => {
    const {selectedParameters} = this.state

    const parameterValue = selectedParameters[type] ? null : value

    if (parameterValue) {
      this.setState({
        selectedParameters: {
          ...selectedParameters,
          [type]: parameterValue
        }
      })
    } else {
      this.setState({
        selectedParameters: _.omit(selectedParameters, [type])
      })
    }
  }

  hasActiveParameter() {
    const {selectedParameters} = this.state

    return Object.keys(selectedParameters)
      .find(param => !!selectedParameters[param])
  }

  selectChannel = item => {
    if (!item) {
      this.setState({selectedChannel: null})
    } else {
      const {channelTypeId, channelGroupId, channelId} = item
      if (!channelGroupId || !channelId) {
        this.setState({selectedChannel: null})
      } else {
        this.setState({
          selectedChannel: {channelTypeId, channelGroupId, channelId}
        })
      }
    }
  }

  saveUnmappedChannel = () => {
    const {mapUtms} = this.props
    const {
      selectedParameters,
      selectedChannel
    } = this.state

    const disabled = !(this.hasActiveParameter() && selectedChannel)
    if (disabled) return

    const {channelTypeId, channelGroupId, channelId} = selectedChannel

    mapUtms({
      selectedParameters,
      channelTypeId,
      channelGroupId,
      channelId
    })
  }
}

const mapStateToProps = state => ({
  unmappedUtms: getUnmappedUtms(state),
  isMapUnmappedChannelSaving: getMapUnmappedChannelSaving(state),
  isUtmUnmappingsFetching: state.settings.isUtmUnmappingsFetching
})

export default connect(mapStateToProps, {
  fetchUnmappedUtms,
  mapUtms
})(UmMappedView)



// WEBPACK FOOTER //
// ./client/views/SettingsUtmMappingView/UnMappedView.js